'use client';

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import Link from 'next/link';
import { withLocaleHref } from '@/i18n/config';

interface SignUpPromptDialogProps {
  open: boolean;
  onClose: () => void;
  locale: string;
  t: (key: string) => string;
}

export function SignUpPromptDialog({
  open,
  onClose,
  locale,
  t,
}: SignUpPromptDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{t('limitTitle')}</DialogTitle>
          <DialogDescription>{t('limitBody')}</DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-3 pt-2">
          <Button asChild size="lg">
            <Link href={withLocaleHref('/register', locale)}>
              {t('createAccount')}
            </Link>
          </Button>
          <Button asChild variant="outline" size="lg">
            <Link href={withLocaleHref('/login', locale)}>{t('signIn')}</Link>
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
